import { SpyneTrait, ViewStream } from "spyne";

export class CodePlaygroundExamplesIntroTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codePlagroundExamples$Intro";

    super(context, traitPrefix);
  }

  static codePlagroundExamples$IntroHelloWorld() {
    const props = {
      tagName: "h1",
      style: "font-family:sans-serif;",
      data: "Hello World",
    };
    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    return `
      class MyViewStream extends ViewStream {
        
        constructor(props={}{
          props.tagName = 'h1';
          props.data = 'Hello World';
       
        }
      
      
      }
      `;
  }
}
